import React, { Fragment } from 'react';

import { getCreditWalletInfo } from '../components/globals';
import { Languages } from './languages';

export class EbayConnector extends React.Component {

    constructor(props) {
        super(props);
        /*
         *  props = {
         *      
         *      onDone: function(token)
         *      ebayDto = ...marketPlacePars
         *      forceLogin: bool
         *  }
         */
        this.state = {
            dto: props.ebayDto
        };
    }

    componentDidMount() {

        let self = this;
        window.handleEbayAccessResponse = (data) => {
            try {
                clearInterval(this.timer);
                self.ebayPopup.close();
                self.ebayPopup = null;
                //window.handleEbayAccessResponse = null;
            }
            catch (e) { }

            if (data && data.token) {
                self.props.onDone(data.token);
            }
            else {
                self.props.popupErrorMessage(Languages.getSection("Ebay").authorizationErrorMsg);
                self.props.onDone('');
            }
        }


        let baseurl = this.state.dto.url;
        if (baseurl.endsWith('/')) baseurl = baseurl.substr(0, url.length - 1);
        let url = baseurl.replace('/api.', '/auth.');

        url += "/oauth2/authorize";
        url += "?client_id=" + this.state.dto.clientId;
        url += "&redirect_uri=" + this.state.dto.redirectUrl;
        url += "&scope=" + this.state.dto.scope;
        url += "&response_type=code";
        if(this.props.forceLogin)
            url += "&prompt=login";
        this.ebayPopup = window.open(url, "_blank", "width=520,height=600");
        this.timer = setInterval(() => { if (this.ebayPopup == null || this.ebayPopup.closed) window.handleEbayAccessResponse() }, 500);
    }

    render() {
        try {
            this.ebayPopup.focus();
        }
        catch (e) { }

        return this.ebayPopup == null || this.ebayPopup.closed ? null : <div />;
    }
    
}